<template>
    <div class="estore-body">
        <div class="estore-content inventory-content key-account-content">
            <b-row>
                <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                    <div class="filter-wrapper">
                        <b-input-group prepend=" ">
                            <b-form-input @keyup.native="search(true)" placeholder="Search" v-model="filter.keyword"></b-form-input>
                            <b-dropdown text="Advanced" variant="primary" slot="append">
                                <b-dropdown-item @click="searchOption(field.key)" v-for="(field, index) in searchFields" :key="index">
                                    {{ field.label }}
                                    <i v-if="filter.field === field.key" class="ml-1"> <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1">
                                    </i>
                                </b-dropdown-item>
                            </b-dropdown>
                        </b-input-group>
                    </div>
                </b-col>
                <b-col sm="3" md="3">
                    <div class="filter-wrapper">
                        <b-form-select />
                    </div>
                </b-col>
            </b-row>
            <div class="mt-3 products">
                <div class="data-container">
                    <b-table
                        :items="isSearchType ? [] : list"
                        :fields="fields"
                        :current-page="page"
                        ref="customerList"
                        responsive
                        show-empty
                        :empty-text="(loading) ? 'Loading data' : emptyText"
                    >
                        <template slot="customer_name" slot-scope="data">
                            {{
                                data.item.firstname + ' ' + data.item.lastname
                            }}
                        </template>
                        <template slot="key_account" slot-scope="data">
                            <template v-if="data.item.metas.length != 0">
                                {{ data.item.metas[0].value }}
                            </template>
                        </template>
                        <template slot="company_code_status" slot-scope="data" >
                            <span :class="data.value + '-container table-status-container d-inline-block'" style="text-align: left !important;">{{ data.value.replace("_", " ") }}</span>
                        </template>
                        <template slot="action" slot-scope="data">
                            <template v-if="data.item.company_code_status == 'pending'">
                                <b-button v-bind:disabled="loading" class="approve-btn mr-3" @click="forApproval(data.item.uuid)">
                                    <img width="15" height="15" src="@/assets/images/icons/key-account-approve.svg" alt="">
                                    Approve
                                </b-button>
                                <b-button v-bind:disabled="loading" class="reject-btn" @click="forRejection(data.item.uuid)">
                                    <img width="15" height="15" src="@/assets/images/icons/key-account-reject.svg" alt="">
                                    Reject
                                </b-button>
                            </template>
                            <template v-else>
                                <b-button v-bind:disabled="loading" class="update-btn" @click="callUpdateModal(data.item.uuid, data.item.firstname, data.item.lastname, data.item.metas)">
                                    <img width="15" height="15" src="@/assets/images/icons/key-account-update.svg" alt="">
                                    Update
                                </b-button>
                            </template>
                        </template>
                    </b-table>
                </div>
                <div class="confirmation-modal px-3 pt-3 pb-5" v-if="displayConfirmationModal">
                    <img
                        src="@/assets/images/icons/confirm.svg"
                        alt="Confirm Icon"
                        class="d-inline-block mr-1"
                        style="width: 40px; height: 40px; margin-left: 80px !important;"
                    />
                    <p class="d-inline-block ml-2 mb-0">
                        Are you sure you want to approve this account?
                    </p>
                    <br>
                    <b-button v-bind:disabled="loading" @click="displayConfirmationModal = false" id="cancel-btn" variant="outline-secondary" class="text-right">
                        Cancel
                    </b-button>
                    <b-button v-bind:disabled="loading" @click="sendForApproval" id="yes-btn" variant="outline-primary" class="text-right">
                        Yes
                    </b-button>
                </div>
                <div class="approved-modal px-3 pt-3 pb-5" v-if="displayApprovedModal">
                    <img
                        src="@/assets/images/icons/approved.svg"
                        alt="Approved Icon"
                        class="d-inline-block mr-1"
                        style="width: 40px; height: 40px; margin-left: 80px !important;"
                    />
                    <p class="d-inline-block ml-2 mb-0">
                        Account has been approved!
                    </p>
                    <br>
                    <b-button v-bind:disabled="loading" id="done-btn" variant="outline-success" class="text-right">
                        Done
                    </b-button>
                </div>
            </div>
            <div>
                <b-row>
                    <b-col>
                        <div class="mt-1">
                            <span class="pagination-indicator">Showing {{ startList }} to {{ endList }} of {{ maxPage }} per page</span>
                        </div>
                    </b-col>
                    <b-col>
                        <b-pagination
                            hide-goto-end-buttons
                            align="right"
                            size="md"
                            :total-rows="maxPage * list.length"
                            :limit="5"
                            :per-page="list.length"
                            @change="paginate"
                            :value="page"
                            class="custom-pagination">
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <UpdateKeyAccount :status="modal.update.status" :keyAccountsOptions="keyAccountsOptions" :uuid="selectedUuid" :firstname="selectedFirstName" :lastname="selectedLastName" :metas="selectedMetas" />
    </div>
</template>

<script>
import UpdateKeyAccount from "@/views/customers/key-account/UpdateKeyAccount";
import Pagination from "@/views/customers/key-account/Pagination";
import { mapState } from "vuex";
import _ from "lodash";

export default {
    name: "key-account",
    data() {
        return {
            filter: {
                keyword: null,
                field: "all",
                dateFrom: null,
                dateTo: null
            },
            searchFields: [
                {
                    key: "all",
                    label: "All"
                },
                {
                    key: "firstname",
                    label: "First Name"
                },
                {
                    key: "lastname",
                    label: "Last Name"
                },
                {
                    key: "email",
                    label: "Email"
                },
                {
                    key: "mobile_number",
                    label: "Mobile Number"
                },
                {
                    key: "registration_channel",
                    label: "Registration Channel"
                }
            ],
            fields: [
                {
                    key: "customer_name",
                    sortable: true
                },
                {
                    key: "key_account",
                    sortable: true
                },
                {
                    key: "channel",
                    sortable: true
                },
                {
                    key: "company_code_status",
                    label: "Status",
                    sortable: true
                },
                { key: "action", sortable: false }
            ],
            emptyText: "No Records Found",
            isSearchType: false,
            displayConfirmationModal: false,
            displayApprovedModal: false,
            selectedCustomerUuid: null,
            selectedUuid: null,
            selectedFirstName: "",
            selectedLastName: "",
            selectedMetas: []
        };
    },
    computed: {
        ...mapState("keyAccount", [
            "modal",
            "loading",
            "errors",
            "list",
            "keyAccountsOptions",
            "page",
            "perPage",
            "maxPage",
            "nextPage",
            "prevPage",
            "startList",
            "endList"
        ])
    },
    components: {
        UpdateKeyAccount,
        Pagination
    },
    created: function() {
        this.$store.dispatch("keyAccount/getFirstPage");
        this.$store.dispatch("keyAccount/getKeyAccountsOptions");
    },
    methods: {
        paginate(page) {
            this.$store.commit("keyAccount/setPage", page);
            this.$store.dispatch("keyAccount/getList");
        },
        callUpdateModal: async function(uuid, firstname, lastname, metas) {
            this.selectedUuid = uuid;
            this.selectedFirstName = firstname;
            this.selectedLastName = lastname;
            this.selectedMetas = metas.length != 0 ? metas[0].value : null;

            this.$store.commit("keyAccount/setModal", {
                type: "update",
                status: true
            });
        },
        search(newSearch = false, page) {
            this.$store.commit("keyAccount/setSearchDefault");
            this.$store.commit("keyAccount/setSearchFilter", this.filter);

            if (this.filter.keyword.trim() === "") {
                return this.$store.dispatch("keyAccount/getFirstPage");
            }

            if (newSearch) {
                this.emptyText = "Searching...";
                this.isSearchType = true;
            }

            let _this = this;
            this.$store.dispatch("keyAccount/getFirstPage").then(() => {
                _this.emptyText =
                    'No Records Found for "' + _this.filter.keyword + '"';
                _this.isSearchType = false;
            });
            // this.$store.dispatch("rewards/search", param).then(() => {
            //     _this.emptyText =
            //         'No Records Found for "' + _this.searchString + '"';
            //     _this.isSearchType = false;
            // });
        },
        forApproval: async function(id) {
            this.selectedCustomerUuid = id;
            this.displayConfirmationModal = true;
        },
        sendForApproval: async function() {
            let param = {
                customer_uuid: this.selectedCustomerUuid,
                status: "approved"
            };

            let _this = this;
            await this.$store
                .dispatch("keyAccount/updateCompanyCodeStatus", param)
                .then(function() {
                    if (_.isEmpty(_this.errors)) {
                        _this.$store.dispatch("keyAccount/getFirstPage");
                        _this.displayConfirmationModal = false;
                        _this.selectedCustomerUuid = null;
                    }
                });
        },
        forRejection: async function(id) {
            this.selectedCustomerUuid = id;

            let param = {
                customer_uuid: id,
                status: "rejected"
            };

            let _this = this;
            await this.$store
                .dispatch("keyAccount/updateCompanyCodeStatus", param)
                .then(function() {
                    if (_.isEmpty(_this.errors)) {
                        _this.$store.dispatch("keyAccount/getFirstPage");
                        _this.selectedCustomerUuid = null;
                    }
                });
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
